import React, { FC, ReactNode } from 'react';

import ComposeContainer from '../../../../containers/compose';
import FloatingBottomNav from '../../../FloatingBottomNav';

import useSettingsNavigation from './hooks/useSettingsNavigation';

type Props = {
  floatingButton?: ReactNode;
};

/**
 * Footer region for the settings pages
 *
 * @param props                Props passed to the component
 * @param props.floatingButton Floating button to show about the navigation
 * @returns                    The component itself
 */
const SettingsLayoutFooter: FC<Props> = ({ floatingButton }) => {
  const { shouldShowCompose, shouldShowFloatingButton } =
    useSettingsNavigation();

  return (
    <>
      {shouldShowCompose && <ComposeContainer nodeType="TEMPLATE" />}
      {shouldShowFloatingButton && (
        <FloatingBottomNav floatingButton={floatingButton} />
      )}
    </>
  );
};

export default SettingsLayoutFooter;
